import React,{useEffect} from 'react';
//import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
//import Title from './Title';

const Sorry = ()=> {
    const classes = useStyles();
    useEffect(()=>{
        window.scrollTo(0,0);
    },[]);    
    return (
        <div id="company" className={classes.root+" "+classes.policy}>
            <Paper className={classes.paper}>
				<Box style={{textAlign:'center'}}>
                こちらの機能は現在休止中です<br/>
				（近日中に再開します）<br/>
				</Box>
            </Paper>
        </div>
    )
}

export default Sorry;